__turbopack_context__.v({
  "award-item": "style-module-scss-module__O--LLG__award-item",
  "award-name-container": "style-module-scss-module__O--LLG__award-name-container",
  "award-rank": "style-module-scss-module__O--LLG__award-rank",
  "award-rank-container": "style-module-scss-module__O--LLG__award-rank-container",
  "carousel-container": "style-module-scss-module__O--LLG__carousel-container",
  "carousel-inner": "style-module-scss-module__O--LLG__carousel-inner",
  "carousel-item": "style-module-scss-module__O--LLG__carousel-item",
  "carousel-title": "style-module-scss-module__O--LLG__carousel-title",
  "forbes-award": "style-module-scss-module__O--LLG__forbes-award",
  "glass-door-award": "style-module-scss-module__O--LLG__glass-door-award",
  "row-award": "style-module-scss-module__O--LLG__row-award",
  "row-award-deloitte": "style-module-scss-module__O--LLG__row-award-deloitte",
  "zoo-award": "style-module-scss-module__O--LLG__zoo-award",
});
